export default __webpack_public_path__ + "static/krzysztofk-4d2ec0533b7cf83914391fa41150bf51.jpg";